import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => { const { name, value } = e.target; setFormData((p) => ({ ...p, [name]: value })); setSubmitError(""); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");
    setSubmitSuccess(false);
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "contacts"), { name: formData.name.trim(), email: formData.email.trim(), message: formData.message.trim(), createdAt: serverTimestamp() });
      setFormData({ name: "", email: "", message: "" });
      setSubmitSuccess(true);
    } catch (err) { setSubmitError(err.message || "Failed to send. Please try again."); } finally { setIsSubmitting(false); }
  };

  return (
    <section id="contact" className="w-full min-w-full h-full flex-shrink-0 snap-start flex items-center justify-center bg-gray-100 p-4 sm:p-6 md:p-8 overflow-y-auto">
      <div className="max-w-4xl w-full bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-8 my-4 sm:my-0">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-red-600 mb-4 sm:mb-6 text-center">Contact</h2>
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          <div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">Get in Touch</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4"><label className="block text-gray-700 font-bold mb-2">Name</label><input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 text-base min-h-[44px] touch-manipulation" required /></div>
              <div className="mb-4"><label className="block text-gray-700 font-bold mb-2">Email</label><input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 text-base min-h-[44px] touch-manipulation" required /></div>
              <div className="mb-4"><label className="block text-gray-700 font-bold mb-2">Message</label><textarea id="message" name="message" rows="4" value={formData.message} onChange={handleChange} className="w-full px-3 py-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 text-base min-h-[120px] touch-manipulation" required /></div>
              {submitError && <p className="mb-4 text-red-600 text-sm">{submitError}</p>}
              {submitSuccess && <p className="mb-4 text-green-600 text-sm">Thanks! Your message was sent.</p>}
              <button type="submit" disabled={isSubmitting} className="bg-red-600 text-white px-4 py-3 rounded-md hover:bg-red-700 disabled:opacity-50 min-h-[44px] touch-manipulation w-full sm:w-auto">{isSubmitting ? "Sending…" : "Send"}</button>
            </form>
          </div>
          <div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4">Information</h3>
            <p className="text-gray-600 mb-2 text-base sm:text-inherit">Patrick Driscoll — REALTOR, Broker Driscoll Co.</p>
            <p className="text-gray-600 mb-2">613 Belson Ct. St.Louis, Mo. 63122</p>
            <p className="text-gray-600 mb-2">Email: patrick@driscollcorp.com</p>
            <p className="text-gray-600 mb-4">Phone: (314) 922-3810</p>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 mt-6 sm:mt-8">Services</h3>
            <ul className="list-disc list-inside text-gray-600 text-base sm:text-inherit"><li>Residential, Commercial, Investment</li><li>Landlord/Tenant Representation</li></ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
